import { connect } from 'react-redux';
import OccupationSalaryRange from '../../../components/UploadDocuments/OccupationSalaryRange';

import {
  updateOccupationSalaryRange
} from '@xanadu/ui-shared/modules/user/actions';

import {
  logout
} from '@xanadu/ui-shared/modules/userSession/actions';

const mapDispatchToProps = {
  updateOccupationSalaryRange,
  logout
};

function mapStateToProps(state) {
  return {
    isLoading: state.getIn(['user', 'updateLoading']),
    errorMessage: state.getIn(['user', 'errorMessage']),
    proofOfAddressStatus: state.getIn(['user', 'proofOfAddressStatus']),
    proofOfIdentityStatus: state.getIn(['user', 'proofOfIdentityStatus']),
    jobTitle: state.getIn(['user', 'jobTitle']),
    salaryRange: state.getIn(['user', 'salaryRange']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OccupationSalaryRange);

